module.exports = __webpack_public_path__ + "assets/images/project/head/Pratima_Sherpa.jpg?v=ddce1b6d";